import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import {getAvailableColumns} from "pages/PageDoneApplications/api";

export const path = '/doneApplications';

const PageConsultations: React.FC = (props) => {
    const loader = {
        page: () => import('pages/PageDoneApplications/page'),
        columns: getAvailableColumns
    };

    const Consultations = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded, loadedProps) {
            const Page = loaded.page.default

            return (
                <Page
                    {...loadedProps}
                    {...props}
                    columns={loaded.columns}
                />
            )
        }
    });

    return <Consultations/>;
};

export default PageConsultations;
